import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

// Fonction utilitaire pour détecter la saison actuelle
const getSeasonalTheme = () => {
  const month = new Date().getMonth(); // 0 = Janvier, 11 = Décembre
  
  if (month === 11) { // Si on est en Décembre
    return 'christmas';
  }
  // Tu pourras ajouter d'autres mois ici (ex: Octobre -> Halloween)
  return null; // Pas de saison spéciale
};

export const ThemeProvider = ({ children }) => {
  // 1. État de base : 'light' ou 'dark' préféré par l'utilisateur
  const [baseMode, setBaseMode] = useState(() => {
    if (typeof window !== "undefined") {
        const saved = localStorage.getItem("baseThemeMode");
        // Si pas de sauvegarde, on regarde la préférence système, sinon 'dark' par défaut
        if (!saved) {
             return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        }
        return saved;
    }
    return 'dark';
  });

  // 2. État des saisons : Est-ce que l'utilisateur veut la magie automatique ?
  const [seasonalEnabled, setSeasonalEnabled] = useState(() => {
    if (typeof window !== "undefined") {
      // Par défaut, on active les saisons (true) sauf si l'utilisateur a dit non
      return localStorage.getItem("seasonalThemeEnabled") !== "false";
    }
    return true;
  });

  // Calcul du thème ACTIF : C'est celui qui sera appliqué
  const currentSeason = getSeasonalTheme();
  // Si les saisons sont activées ET qu'on est dans une saison spéciale, on applique la saison.
  // Sinon, on applique le mode de base (clair/sombre).
  const activeTheme = (seasonalEnabled && currentSeason) ? currentSeason : baseMode;

  // Effet pour appliquer les classes CSS sur le <html>
  useEffect(() => {
    const root = window.document.documentElement;
    // On nettoie les anciennes classes
    root.classList.remove('light', 'dark', 'christmas');
    // On ajoute la nouvelle classe active
    root.classList.add(activeTheme);
    
    // Sauvegarde des préférences
    localStorage.setItem("baseThemeMode", baseMode);
    localStorage.setItem("seasonalThemeEnabled", seasonalEnabled);
  }, [baseMode, seasonalEnabled, activeTheme]);

  // Fonctions pour les boutons du Header
  const toggleBaseMode = () => {
    setBaseMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  const toggleSeasonal = () => {
    setSeasonalEnabled((prev) => !prev);
  };

  return (
    <ThemeContext.Provider value={{ 
      baseMode, 
      toggleBaseMode, 
      seasonalEnabled, 
      toggleSeasonal,
      activeTheme,
      currentSeason // Utile pour savoir si une saison est dispo même si désactivée
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);